import { render, staticRenderFns } from "./ConfirmCsvRemovalModal.vue?vue&type=template&id=7067a0cf&scoped=true"
import script from "./ConfirmCsvRemovalModal.vue?vue&type=script&lang=js"
export * from "./ConfirmCsvRemovalModal.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCsvRemovalModal.vue?vue&type=style&index=0&id=7067a0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067a0cf",
  null
  
)

export default component.exports